/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';

class cumulativecalculation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calculationField: ''
    };
    const { isRequired, handleFieldErrorChanged, fieldId } = this.props;
    const { calculationField } = this.state;

    if (isRequired && !calculationField) {
      handleFieldErrorChanged(fieldId, false);
    }
  }

  render() {
    const { fieldId, max, min, keypress, calculationField } = this.props;
    return (
      <>
         <input
            type="number"
            name={`number-field-${fieldId}`}
            defaultValue={calculationField}
            max={max}
            min={min}
            editable={false}
            onKeyPress={e => (keypress ? keypress(e) : '')}
            className="pulpo-numberfield"
            placeholder={calculationField}
            disabled
            value={calculationField} />
      </>
    );
  }
}

export default cumulativecalculation;
